import {slideDown, slideUp} from "./utilities/slide";

function switchDCOrderMotive(img, id, targets) {
    const dcOrderSelectedMotive = document.querySelector('.js-dcOrderSelectedMotive');
    const dcOrderinputSelectedMotive = document.querySelector('.js-dcOrderInputSelectedMotive');

    if (dcOrderinputSelectedMotive && dcOrderinputSelectedMotive) {
        dcOrderSelectedMotive.src = img;
        dcOrderinputSelectedMotive.value = id;
        for (const target of targets) {
            target.classList.remove("is-active");
            if (target.dataset.id) {
                if (target.dataset.id === id) {
                    target.classList.add("is-active");
                }
            }
        }
    }
}

function switchDCOrderTag(id, targets, individual = false) {
    const dcOrderinputTag = document.querySelector('.js-dcOrderTagInput');
    const dcOrderIndividualinput = document.querySelector('.js-dcOrderIndividualInput');

    if (dcOrderinputTag) {
        dcOrderinputTag.value = id;
        for (const target of targets) {
            target.classList.remove("is-active");
            if (target.dataset.id) {
                if (target.dataset.id === id) {
                    target.classList.add("is-active");
                }
            }
        }
    }
    if (dcOrderIndividualinput && !individual) {
        dcOrderIndividualinput.value = "";
    }
}

function initSwitchDcOrderMotive() {
    const dcOrderSwitchTargets = document.querySelectorAll('.js-dcOrderSwitchMotive');
    if (dcOrderSwitchTargets) {
        for (const target of dcOrderSwitchTargets) {
            target.addEventListener("click", function () {
                if (target.dataset.bigImage && target.dataset.id) {
                    switchDCOrderMotive(target.dataset.bigImage, target.dataset.id, dcOrderSwitchTargets);
                }
            });
        }
    }
}

function initSwitchDcOrderTags() {
    const dcOrderTags = document.querySelectorAll('.js-dcOrderTag');
    if (dcOrderTags) {
        for (const target of dcOrderTags) {
            target.addEventListener("click", function () {
                if (target.dataset.id) {
                    switchDCOrderTag(target.dataset.id, dcOrderTags);
                }
            });
        }
    }
}

function initIndividualDcOrderInput() {
    const dcOrderIndividualinput = document.querySelector('.js-dcOrderIndividualInput');
    const dcOrderTags = document.querySelectorAll('.js-dcOrderTag');
    if (dcOrderIndividualinput) {
        dcOrderIndividualinput.addEventListener("keyup", function () {
            switchDCOrderTag(0, dcOrderTags, true);
        });
    }
}

function initToggleOrderMailSlide(query = document.querySelectorAll(".js-dcOrderMailToggleLink")) {
    for (const toggle of query) {
        toggle.addEventListener("click", function () {
            const dataset = toggle.dataset;
            let toggleTar = "";
            let wrapper = toggle.closest('.js-dcOrderMailToggle');

            if (dataset.toggleTarget) {
                toggleTar = dataset.toggleTarget;
            } else {
                console.error("toggle targets not defined");
                return;
            }

            if (wrapper === null) {
                wrapper = document;
            }

            for (const target of (wrapper.querySelectorAll('.js-dcOrderMailInput'))) {
                if (target.classList.contains(toggleTar)) {
                    slideDown(target, 200, "linear", function () {
                        const input = target.querySelector('input');
                        if (input) {
                            input.focus();
                        }
                    });
                } else {
                    slideUp(target, 200, "linear");
                }
            }
        });
    }
}

function initDcOrder(){
    initSwitchDcOrderMotive();
    initSwitchDcOrderTags();
    initIndividualDcOrderInput();
    initToggleOrderMailSlide();
}

export default initDcOrder;